import { Component, Input, ViewChild } from '@angular/core';
import { User } from '../../../models/identity/user.model';
import { UserInfosFormComponent } from '../../../shared/components/user/user-infos-form/user-infos-form.component';
import { AccountsService } from '../../../services/identity/accounts.service';

@Component({
    selector: 'app-onboarding-user-infos',
    templateUrl: './onboarding-user-infos.component.html',
    styleUrls: ['./onboarding-user-infos.component.scss'],
})
export class OnboardingUserInfosComponent {
    public currentUser: User;
    @ViewChild(UserInfosFormComponent) public userInfoComponent: UserInfosFormComponent;

    constructor(private readonly accountService: AccountsService) {
        this.currentUser = accountService.currentUser;
    }

    public save(): Promise<boolean> {
        return this.userInfoComponent.save();
    }
}